import React, { useState, useEffect } from "react";
import { Route, Routes } from 'react-router-dom';
import Preloader from "../components/Preloader";

//Custom Components

import Home from '../pages/home';
import HomeTwo from '../pages/home-2';
import HomeThree from '../pages/home-3';
import About from '../pages/about';
import Course from '../pages/course';
import CourseList from '../pages/course/course-list';
import CourseDetails from '../pages/course/course-details';
import CourseSidebar from '../pages/course/course-sidebar';
import Instructor from '../pages/instructor';
import InstructorDetails from '../pages/instructor/instructor-details';
import Event from '../pages/event';
import EventSidebar from '../pages/event/event-sidebar';
import EventDetails from '../pages/event/event-details';
import Blog from '../pages/blog';
import BlogDetails from '../pages/blog/blog-details';
import Login from '../pages/authentication/login';
import Signup from '../pages/authentication/signup';
import Contact from '../pages/contact';
import Error from '../pages/404';
import LoadTop from '../components/ScrollTop/LoadTop'
import GovtPartners from "../pages/Partner/GovtPartners";
import IndustryPartner from "../pages/Partner/IndustryPartner";
import Story from "../pages/Story";
import StoryDetail from "../pages/Story/StoryDetail";
import Award from "../pages/Award";
import Career from "../pages/Career";
import Training from "../pages/training";
import TrainingDetail from "../pages/training/trainingDetails";
import Media from "../pages/media";


const App = () => {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate data loading delay
        setTimeout(() => {
        setIsLoading(false);
        }, 500);
    }, []);

    return (
        <div className='App'>
            {isLoading ?
                <Preloader /> : ''
            }
            <>
                <LoadTop />
                <Routes>
                    <Route path="/" exact element={<Home />} />
                    {/* <Route path="/home-2" element={<HomeTwo />} />
                    <Route path="/home-3" element={<HomeThree />} /> */}
                    <Route path="/about" element={<About />} />
                    <Route path="/goverment-partners" element={<GovtPartners/>}/>
                    <Route path="/industry-partners" element={<IndustryPartner/>}/>
                    <Route path="/course" exact element={<Course />} />
                    <Route path="/course-list" exact element={<CourseList />} />
                    <Route path="/course/:id" element={<CourseDetails />} />
                    <Route path="/course-sidebar" element={<CourseSidebar />} />
                    <Route path="/success-story" element={<Story/>}/>
                    <Route path="/success-story-detail/:slug" element={<StoryDetail/>}/>
                    <Route path="/award-&-recognition" element={<Award/>}/>
                    <Route path="/media" element={<Media/>}/>
                    <Route path="/career" element={<Career/>}/>
                    <Route path="/training" element={<Training/>}/>
                    <Route path="/training/:slug" element={<TrainingDetail/>}/>
                    {/* <Route path="/event" exact element={<Event />} />
                    <Route path="/event/:id" element={<EventDetails />} />
                    <Route path="/event-sidebar" element={<EventSidebar />} /> */}
                    <Route path="/blog" exact element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogDetails />} />
                    {/* <Route path="/instructor" exact element={<Instructor />} />
                    <Route path="/instructor/:id" exact element={<InstructorDetails />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} /> */}
                    <Route path="/contact" element={<Contact />} />
                    <Route path='*' element={<Error />} />
                </Routes>
            </>
        </div>
    );
}

export default App;
